/* 4S Zijmenu 2.0 (2-11-2026) */
(function () {
  if (customElements.get('s4-zijmenu')) return;

  var euro = function (v) {
    var n = Number(v);
    if (isNaN(n)) return '';
    return '€ ' + n.toLocaleString('nl-NL', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  class S4Zijmenu extends HTMLElement {
    connectedCallback() {
      this.start = this.querySelector('[data-start]');
      /* Knoppen zijn <a role="button">: Dawn sluit het menu bij elke <button> in de lade. */
      this.querySelectorAll('a[role="button"]').forEach((b) => b.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); b.click(); }
      }));
      this.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); this.open(b.dataset.open, b); }));
      this.querySelectorAll('[data-terug]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); this.terug(); }));
      this.querySelectorAll('[data-uitklap]').forEach((b) => b.addEventListener('click', (e) => {
        e.preventDefault();
        var doel = document.getElementById(b.getAttribute('aria-controls'));
        if (!doel) return;
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        doel.hidden = open;
      }));
      var sluit = this.querySelector('[data-sluit]');
      if (sluit) sluit.addEventListener('click', (e) => { e.preventDefault(); this.sluit(e); });
      this.addEventListener('keyup', (e) => { if (e.key === 'Escape' && this.actief) { e.stopPropagation(); this.terug(); } });

      this.zoek = this.querySelector('[data-zoek]');
      this.res = this.querySelector('[data-resultaten]');
      if (this.zoek) this.zoek.addEventListener('input', () => { clearTimeout(this.tz); this.tz = setTimeout(() => this.zoeken(), 220); });

      this.spelerzoek = this.querySelector('[data-spelerzoek]');
      this.voorraadKnop = this.querySelector('[data-voorraad]');
      this.alleenVoorraad = true;
      if (this.spelerzoek) this.spelerzoek.addEventListener('input', () => this.filter());
      if (this.voorraadKnop) this.voorraadKnop.addEventListener('click', (e) => {
        e.preventDefault();
        this.alleenVoorraad = !this.alleenVoorraad;
        this.voorraadKnop.setAttribute('aria-pressed', this.alleenVoorraad ? 'true' : 'false');
        this.voorraadKnop.classList.toggle('s4-zm__chip--vol', this.alleenVoorraad);
        this.filter();
      });

      var details = this.closest('details');
      if (details) details.addEventListener('toggle', () => { if (details.open) this.laatst(); else this.terug(true); });
      this.laatst();
    }

    sluit(e) {
      var hd = this.closest('header-drawer');
      var summary = hd && hd.querySelector('summary');
      if (hd && typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(e, summary);
      else if (summary) summary.click();
    }

    open(naam, knop) {
      var p = this.querySelector('[data-paneel="' + naam + '"]');
      if (!p) return;
      if (this.actief && this.actief !== p) { this.actief.classList.remove('is-open'); this.actief.hidden = true; }
      this.terugFocus = knop;
      p.hidden = false;
      requestAnimationFrame(() => p.classList.add('is-open'));
      this.actief = p;
      var t = p.querySelector('[data-terug]');
      if (t) t.focus({ preventScroll: true });
      this.start.setAttribute('inert', '');
      if (naam === 'speler') this.voorraad();
    }

    terug(stil) {
      if (!this.actief) return;
      var p = this.actief;
      p.classList.remove('is-open');
      this.actief = null;
      this.start.removeAttribute('inert');
      if (!stil && this.terugFocus) this.terugFocus.focus({ preventScroll: true });
      setTimeout(() => { if (!p.classList.contains('is-open')) p.hidden = true; }, stil ? 0 : 250);
    }

    zoeken() {
      var q = (this.zoek.value || '').trim();
      if (q.length < 2) { this.res.hidden = true; this.res.innerHTML = ''; return; }
      var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      var nr = (this.zoekNr = (this.zoekNr || 0) + 1);
      fetch(url).then((r) => r.json()).then((d) => {
        if (nr !== this.zoekNr) return;
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!items.length) {
          this.res.innerHTML = '<p class="s4-zm__geen">Niets gevonden voor “' + esc(q) + '”. Stuur ons een WhatsApp, dan zoeken we het voor je.</p>';
        } else {
          this.res.innerHTML = items.map(function (p) {
            var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="56" height="56">' : '<span class="s4-zm__geenfoto"></span>';
            return '<a class="s4-zm__hit" href="' + esc(p.url) + '">' + img + '<span><b>' + esc(p.title) + '</b><small>' + (p.available === false ? 'Uitverkocht' : euro(p.price)) + '</small></span></a>';
          }).join('') + '<a class="s4-zm__alles" href="/search?type=product&q=' + encodeURIComponent(q) + '">Bekijk alle resultaten</a>';
        }
        this.res.hidden = false;
      }).catch(() => { this.res.hidden = true; });
    }

    voorraad() {
      if (this.voorraadGeladen) return;
      this.voorraadGeladen = true;
      var lijst = this.querySelector('[data-spelers]');
      if (!lijst) return;
      fetch('/?section_id=4s-zijmenu-spelers').then((r) => r.text()).then((html) => {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var map = {};
        doc.querySelectorAll('[data-url]').forEach((s) => { map[s.dataset.url] = Number(s.dataset.n || 0); });
        lijst.querySelectorAll('li').forEach((li) => {
          var a = li.querySelector('a');
          var n = map[a.getAttribute('href')];
          if (n === undefined) return;
          li.dataset.op = n;
          if (n > 0 && !li.querySelector('.s4-zm__aantal')) {
            a.insertAdjacentHTML('beforeend', '<span class="s4-zm__aantal">' + n + (n === 1 ? ' shirt' : ' shirts') + '</span>');
          }
        });
        this.filter();
      }).catch(() => {});
    }

    filter() {
      var lijst = this.querySelector('[data-spelers]');
      if (!lijst) return;
      var q = (this.spelerzoek && this.spelerzoek.value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ij/g, 'y');
      var zichtbaar = 0;
      lijst.querySelectorAll('li').forEach((li) => {
        var naam = (li.dataset.naam || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ij/g, 'y');
        var ok = naam.indexOf(q) !== -1;
        if (ok && this.alleenVoorraad && li.dataset.op !== undefined && Number(li.dataset.op) === 0) ok = false;
        li.hidden = !ok;
        if (ok) zichtbaar++;
      });
      var leeg = this.querySelector('[data-leeg]');
      if (leeg) {
        leeg.hidden = zichtbaar > 0;
        var wa = leeg.querySelector('[data-wa-speler]');
        if (wa && this.spelerzoek) wa.href = 'https://wa.me/31611193163?text=' + encodeURIComponent('Hallo, ik zoek een gesigneerd shirt van: ' + this.spelerzoek.value);
      }
    }

    laatst() {
      var blok = this.querySelector('[data-laatst-blok]');
      var doel = this.querySelector('[data-laatst]');
      if (!blok || !doel) return;
      var lijst = [];
      try { lijst = JSON.parse(localStorage.getItem('s4-laatst-bekeken') || '[]'); } catch (e) { lijst = []; }
      if (!lijst.length) { blok.hidden = true; return; }
      doel.innerHTML = lijst.slice(0, 3).map(function (x) {
        return '<a href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '<span class="s4-zm__geenfoto"></span>') + '<span>' + esc(x.t) + '</span></a>';
      }).join('');
      blok.hidden = false;
    }
  }

  customElements.define('s4-zijmenu', S4Zijmenu);
})();